import { PayloadAction } from '@reduxjs/toolkit';
import {
  Invitation,
  Member,
  MembershipApplication,
  MembershipMember,
  PrivateSpace,
} from './type';
import { MembershipState } from './state';

const reducers = {
  setMembershipInfo(
    state: MembershipState,
    action: PayloadAction<MembershipApplication>,
  ): MembershipState {
    state.membership = action.payload;
    return state;
  },
  setMember(
    state: MembershipState,
    action: PayloadAction<MembershipMember>,
  ): MembershipState {
    state.member = action.payload;
    return state;
  },
  setMembers(
    state: MembershipState,
    action: PayloadAction<Member[]>,
  ): MembershipState {
    state.members = action.payload;
    return state;
  },
  setMembershipPrivateSpace(
    state: MembershipState,
    action: PayloadAction<PrivateSpace[]>,
  ): MembershipState {
    state.membershipSpace = action.payload;
    return state;
  },
  setExceptMember(
    state: MembershipState,
    action: PayloadAction<Member[]>,
  ): MembershipState {
    state.exceptMembers = action.payload;
    return state;
  },
  setNumper(
    state: MembershipState,
    action: PayloadAction<number>,
  ): MembershipState {
    state.numperMember = action.payload;
    return state;
  },
  setLogoutMember(state: MembershipState): MembershipState {
    state.membership = null;
    state.member = null;
    state.members = [];
    state.membershipSpace = [];
    state.exceptMembers = [];
    state.numperMember = 0;
    state.invite_code = null;
    return state;
  },
  setInviteCode(
    state: MembershipState,
    action: PayloadAction<Invitation>,
  ): MembershipState {
    state.invite_code = action.payload;
    return state;
  },
};

export default reducers;
